module.exports = __webpack_public_path__ + "img/profile-photo-empty.8cb04c92.png";